import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import Reply from "./reply";
import "./style.scss";
import ReplyComment from "./replyComment";
import ApiUtils from "../../utils/api_utils";
import * as Assets from "./../../utils/svg_assets";
import BlockReportPage from "../../pages/BlockReportPage";

const Comment = (props) => {
  const { data, onDisplay = () => {} } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState(0);
  const [commentId, setSelectedCommentId] = useState(0);
  const [creatorId, setSelectedcreatorId] = useState(0);
  const [creatorName, setSelectedcreatorName] = useState(0);
  const [openModal, setIsOpenModal] = useState(false);

  const handleToggle = (id) => {
    setId(id);
    setIsOpen(!isOpen);
    onDisplay();
  };

  return (
    <div>
      {data
        ? data.map((item) => {
            return (
              <Row key={item.id}>
                <Col xs={2} sm={2} md={2}>
                  <div className="mr-1">
                    <img
                      src={ApiUtils.validateImgUrl({ url: item.creator.image })}
                      height="100%"
                      className="circular-image"
                      alt=""
                    />
                  </div>
                </Col>
                <Col>
                  <div>
                    <Row className=" fs-12 mb-2">
                      <Col xs={2}>{item.creator.name}</Col>
                      <Col xs={8}>
                        {moment(item.created).format("YYYY-MM-DD")}
                      </Col>
                      <Col>
                        <img
                          src={Assets.dot}
                          onClick={() => {
                            setIsOpenModal(true);
                            setSelectedCommentId(item.id);
                            setSelectedcreatorId(item.creator.id);
                            setSelectedcreatorName(item.creator.name);
                          }}
                        />
                      </Col>
                    </Row>
                    <div className="fs-16 mb-2">{item.text}</div>
                    <div
                      className="d-flex justify-content-between fs-12 text-gray-400 mb-2"
                      onClick={() => handleToggle(item.id)}
                    >
                      <div>Reply</div>
                      <div>{item.replies.length} Comment</div>
                    </div>
                    {item.replies.length > 0
                      ? item.replies.map((reply) => {
                          return (
                            <Reply
                              key={reply.id}
                              data={reply}
                              handleClick={(data) => {
                                setIsOpenModal(true);
                                setSelectedCommentId(data.id);
                              }}
                            />
                          );
                        })
                      : ""}
                  </div>
                </Col>
              </Row>
            );
          })
        : ""}
      {isOpen ? (
        <div className="page-detail-like-comment">
          <ReplyComment id={id} data={data} onClick={handleToggle} />
        </div>
      ) : (
        ""
      )}

      {openModal ? (
        <BlockReportPage
          params={{
            type: "feedcomment",
            id: commentId,
            creator: creatorId,
            creatorName: creatorName,
          }}
          onClose={() => setIsOpenModal(false)}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Comment;
